import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'AdminUsersRole',
    column_type: 'id',
  },
  created_at: {
    model_name: 'AdminUsersRole',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'AdminUsersRole',
    column_type: 'datetime',
  },
  role: {
    model_name: 'AdminUsersRole',
    column_type: 'belongs_to',
    extra: {
      association_name: 'role',
      model_name: 'Role',
    },
  },
  role_id: {
    model_name: 'AdminUsersRole',
    column_type: 'belongs_to',
    extra: {
      association_name: 'role',
      model_name: 'Role',
    },
  },
  admin_user: {
    model_name: 'AdminUsersRole',
    column_type: 'belongs_to',
    extra: {
      association_name: 'admin_user',
      model_name: 'AdminUser',
    },
  },
  admin_user_id: {
    model_name: 'AdminUsersRole',
    column_type: 'belongs_to',
    extra: {
      association_name: 'admin_user',
      model_name: 'AdminUser',
    },
  },
  application: {
    model_name: 'AdminUsersRole',
    column_type: 'belongs_to',
    extra: {
      association_name: 'application',
      model_name: 'Application',
    },
  },
  application_id: {
    model_name: 'AdminUsersRole',
    column_type: 'belongs_to',
    extra: {
      association_name: 'application',
      model_name: 'Application',
    },
  },
  is_block: {
    model_name: 'AdminUsersRole',
    column_type: 'boolean',
  },
  admin_user_attributes: {
    model_name: 'AdminUsersRole',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
